import gql from 'graphql-tag';

export const EnterpriseProgramsByThirdPartyOrganizationIdQuery = gql`
  query EnterpriseProgramsByThirdPartyOrganizationIdQuery($thirdPartyOrganizationId: String!) {
    EnterpriseProgramsV1Resource {
      byThirdPartyOrganizationId(thirdPartyOrganizationId: $thirdPartyOrganizationId) {
        elements {
          id
          userRosters {
            elements {
              id
              contract {
                id
                name
                startsAt
                endsAt
                limitType
                contractState
                utilization {
                  id
                  total
                  remaining
                  totalEnrollment
                  totalUserLicense
                  remainingEnrollment
                  remainingUserLicense
                }
              }
              programInvitations(limit: 1) {
                paging {
                  total
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const EnterpriseProgramBySlugQuery = gql`
  query EnterpriseProgramBySlugQuery($programSlug: String!) {
    EnterpriseProgramsV1Resource {
      slug(slug: $programSlug) {
        elements {
          id
          maxCoursesPerUser
          userRosters {
            elements {
              id
              contract {
                id
                name
                startsAt
                endsAt
                limitType
                contractState
                utilization {
                  id
                  total
                  remaining
                  totalEnrollment
                  totalUserLicense
                  remainingEnrollment
                  remainingUserLicense
                }
                contractTags {
                  elements {
                    id
                    contractTag
                  }
                }
              }
              programInvitations(limit: 1) {
                paging {
                  total
                }
              }
            }
          }
          thirdPartyOrganizationId
          contractId
          metadata {
            name
            description
            slug
            curriculumId
            linkedTargetSkillProfileIds
            launchedAt
            isLocked
            tagline
          }
          curriculumCollections {
            elements {
              id
              courseIds
              s12nIds
            }
          }
        }
      }
    }
  }
`;

export const ProgramsByOrgSlugQuery = gql`
  query ProgramsByOrgSlugQuery($organizationSlug: String!) {
    EnterpriseProgramsV1Resource {
      byOrganizationSlug(organizationSlug: $organizationSlug, limit: 9999) {
        elements {
          id
          metadata {
            slug
            name
            launchedAt
          }
        }
      }
    }
  }
`;

export const ProgramDraftQuery = gql`
  query ProgramDraftQuery($programId: String!) {
    EnterpriseProgramDraftsV1Resource {
      get(id: $programId) {
        id
        status
      }
    }
  }
`;

export const CourseDetailsQuery = gql`
  query CourseDetailsQuery($id: String!) {
    CoursesV1Resource {
      get(id: $id) {
        id
        name
        photoUrl
        partners {
          elements {
            id
            name
          }
        }
      }
    }
  }
`;

export const FirstNameQuery = gql`
  query FirstNameQuery {
    IdVerificationsV1Resource {
      me {
        elements {
          id
          firstName
        }
      }
    }
  }
`;

export const ProgramEnrollmentSettingsQuery = gql`
  query CampusProgramEnrollmentSettingsQuery($programId: String!) {
    ProgramEnrollmentSettingsV1Resource {
      byTargetProgram(programId: $programId) {
        elements {
          id
          enrollmentTarget {
            targetProduct {
              ... on ProgramEnrollmentSettingsV1_courseEnrollmentMember {
                courseEnrollment {
                  targetCourseId
                }
              }
            }
          }
        }
      }
    }
  }
`;
